import { useDateTranslation } from "../../../../hooks/dateTranslation";
import { useFacilityReports } from "../../FacilityReportsList/hooks";

export const useFacilityReportSelectItems = (
  locationId: string,
  currentReportId: number
) => {
  const { translateDate, translateDateRange } = useDateTranslation();

  const { query } = useFacilityReports({
    location_id: locationId,
    sort: "created_at",
    order: "desc",
    limit: 10,
    offset: 0,
    seek_total_count: false,
  });
  const facilityReports = query.data?.data;

  // Hack to use DropdownSelect, which only accepts an array of strings as items.
  // We map each label to a report id and return the id in the onChange handler.
  const timespanIdMap: Record<string, number> = {};

  // Count how many reports share each timespan so we can disambiguate duplicates.
  const timespanCount: Record<string, number> = {};
  for (const report of facilityReports ?? []) {
    const key = translateDateRange(
      new Date(report.start_date),
      new Date(report.end_date)
    );
    timespanCount[key] = (timespanCount[key] ?? 0) + 1;
  }

  // Iterate oldest-first so that lower numbers are assigned to older reports,
  // then reverse items at the end so the dropdown still shows newest first.
  const timespanIndex: Record<string, number> = {};
  for (const report of [...(facilityReports ?? [])].reverse()) {
    const baseKey = translateDateRange(
      // Cast to Date because the data is serialized as a string
      new Date(report.start_date),
      new Date(report.end_date)
    );
    let key = baseKey;
    if (timespanCount[baseKey] > 1) {
      timespanIndex[baseKey] = (timespanIndex[baseKey] ?? 0) + 1;
      key = `${baseKey} (${translateDate(new Date(report.created_at))})`;
      // If creation dates also collide, append a counter as a last resort.
      if (timespanIdMap[key] !== undefined) {
        key = `${key} · ${timespanIndex[baseKey]}`;
      }
    }
    timespanIdMap[key] = report.id;
  }

  const items = Object.keys(timespanIdMap).reverse();

  const selectedItem =
    items.find(
      (item) => Number(timespanIdMap[item]) === Number(currentReportId)
    ) ?? "";

  const getIdForItem = (item: string) => timespanIdMap[item];

  return { items, selectedItem, getIdForItem };
};
